import { Breadcrumbs } from '@/components/breadcrumbs';
import { type BreadcrumbItem } from '@/types';
import React from 'react';
import { Footer } from '../components/footer';
import Header from '../components/header';

interface PageLayoutProps {
  children: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}

export function PageLayout({ children, breadcrumbs }: PageLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      {breadcrumbs && breadcrumbs.length > 1 && (
        <div className="border-b border-border bg-background">
          <div className="container mx-auto flex h-10 items-center px-4 text-sm text-muted-foreground">
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </div>
        </div>
      )}
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
}

export default PageLayout;
